import React from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const ConfirmIcon = ({ size = defaultSize }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M20.6 4.2C21.0418 4.53137 21.1314 5.15817 20.8 5.6L11.8 17.6C11.6261 17.8319 11.3601 17.9769 11.0709 17.9975C10.7817 18.018 10.4979 17.9121 10.2929 17.7071L4.29289 11.7071C3.90237 11.3166 3.90237 10.6834 4.29289 10.2929C4.68342 9.90237 5.31658 9.90237 5.70711 10.2929L10.8918 15.4776L19.2 4.4C19.5314 3.95817 20.1582 3.86863 20.6 4.2Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

ConfirmIcon.propTypes = {
  ...sizePropsTypes,
};

export default ConfirmIcon;
